import { render, staticRenderFns } from "./OutStock.vue?vue&type=template&id=13cc0ab0"
import script from "./OutStock.vue?vue&type=script&lang=js"
export * from "./OutStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports